const FONT_REGISTRY: Record<string, string> = {
  'Poppins': 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap',
  'Oxanium': 'https://fonts.googleapis.com/css2?family=Oxanium:wght@400;500;600;700&display=swap',
  'Source Code Pro': 'https://fonts.googleapis.com/css2?family=Source+Code+Pro:wght@400;500;600;700&display=swap',
  'IBM Plex Mono': 'https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500;600;700&display=swap',
  'Libre Baskerville': 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&display=swap',
  'Lora': 'https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&display=swap',
};

export function ensureRequiredFonts(): void {
  const styles = getComputedStyle(document.documentElement);
  const fonts = [
    styles.getPropertyValue('--font-sans'),
    styles.getPropertyValue('--font-serif'),
    styles.getPropertyValue('--font-mono')
  ];
  
  fonts.forEach(fontDeclaration => {
    const fontName = fontDeclaration?.split(',')[0]?.replace(/['"]/g, '').trim();
    if (fontName && FONT_REGISTRY[fontName]) {
      // Check if already loaded
      if (!document.querySelector(`link[href*="${encodeURIComponent(fontName)}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = FONT_REGISTRY[fontName];
        document.head.appendChild(link);
      }
    }
  });
}